import React, {Fragment, useContext, useEffect, useState} from 'react';
import { useNavigate, Link} from "react-router-dom";
import { InputContext } from '../../contexts/InputContext';
import resourcesServices from '../../services/resourcesServices';
import TextControl from '../customizedInputs/TextControl';
import SelectControl from '../customizedInputs/SelectControl';
import BotonVolver from '../BotonVolver';
import { errorMessage } from '../../errorHandler';
import AsyncSelect from 'react-select/async';
import TextControlObligado from '../customizedInputs/TextControlObligado';

const UsuarioFormPartial = ({id, rol}) => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [renderHTML, setRenderHTML] = useState(false)
  const [usuario, setUsuario] = useState({});
  const [esNuevo, setEsNuevo] = useState(true);
  const [bloquearCampo, setBloquearCampo] = useState(true);
  const [roles, setRoles] = useState([]);
  const [esVeedor, setEsVeedor] = useState(false);
  const [puedeGuardar, setPuedeGuardar] = useState(false);
  const [defaultOptions, setDefaultOptions] = useState([]);
  const [selectedUser, setSelectedUser] = useState({value: '', label: ''});
  const [declaracionesJuradas, setDeclaracionesJuradas] = useState([]);
  const [saving, setSaving] = useState(false);

  const estado_civil = ["soltero", "casado", "viudo", "divorciado"]

  const [camposBasicos, setCamposBasicos] = useState(
    [
      {"section": "Datos Personales",
      "data": {
        "nacionalidad":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.nacionalidad"},
        "telefono_particular":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.telefono_particular"},
        "telefono_laboral":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.telefono_laboral"},
        "estado_civil":{"autocompletar":false,"tipo":"select", "options":estado_civil, "atributo":"preferencias_usuario.estado_civil"},
        "nombre_conyuge":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.nombre_conyuge"},
        "apellido_conyuge":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.apellido_conyuge"},
        }
      },
      {"section": "Domicilio Real",
      "data": {
        "calle_real":{"autocompletar":true,"tipo":"", "atributo":"preferencias_usuario.calle_real"},
        "barrio_real":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.barrio_real"},
        "localidad_real":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.localidad_real"},
        "codigo_postal_real":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.cp_real"},
        }
      },
      {"section": "Domicilio Legal",
      "data": {
        "calle_legal":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.calle_legal"},
        "barrio_legal":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.barrio_legal"},
        "localidad_legal":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.localidad_legal"},
        "cp_legal":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.cp_legal"},
        }
      }
    ]);


  useEffect(() => {
    setEsNuevo( id === undefined )
    if(id){
      fetchUsuario(id, rol)
    } else {
      nuevoUsuario()
    }
  }, [id, rol]);


  // useEffect(() => {

  // }, [currentTab]);


  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( authInformation.autenticado === true){
      setRenderHTML(true)
      if((authInformation.usuario_id == id) && authInformation.rol !== 'Obligado') {
        setBloquearCampo(false)
      } else {
        setBloquearCampo( 
          authInformation.rol === 'Veedor' ||
          authInformation.rol === 'Notificador' ||
          authInformation.rol === 'Obligado' ||
          authInformation.rol === 'Apoderado' ||
          (authInformation.rol === 'MesaEntrada' && rol !== 'Apoderado')
        )
      }

      if( authInformation.rol === 'Admin' || authInformation.rol === 'Veedor' || authInformation.rol === 'MesaEntrada' ){
        obtenerRoles()
      }

      obtenerDeclaracionJurada('','',1,`usuario_id=${id}`)

      setPuedeGuardar( ( authInformation.usuario_id != id ) && (authInformation.rol === 'Veedor' || authInformation.rol === 'Veedor') )

      setEsVeedor(authInformation.rol === 'Veedor' && ( authInformation.usuario_id != id ))
    } else {
      setRenderHTML(false)
    }
  }, [authInformation, id]);

  const obtenerDeclaracionJurada = async (sortBy='', q='', page=1, otro='') => {
    try {
      const data = await resourcesServices.obtenerResources('declaraciones_juradas', sortBy, q, page, otro);
      setDeclaracionesJuradas(data.data);
    } catch (error) {
      errorMessage(error)
    }
  };


  const fetchUsuario = async (id, rol) => {
    try {
      const url_param = rol ? `${id}/${rol}/porRol` : `${id}`
      const data = await resourcesServices.obtenerResourcePorId('usuarios', url_param);

      if(data.preferencias_usuario){
        const updatedCamposBasicos = [ ...camposBasicos];
        updatedCamposBasicos.forEach((obj, idx) => {
          const updatedCamposBasicosData = { ...obj.data};
          for (const key in updatedCamposBasicosData) {
            if (Object.hasOwnProperty.call(updatedCamposBasicosData, key)) {
              const attributeName = updatedCamposBasicosData[key]["atributo"]

              let fieldValue;
              if (attributeName.includes('.')) {
                const [parentKey, childKey] = attributeName.split('.');
                fieldValue = data[parentKey][childKey]
              } else {
                fieldValue = data[attributeName]
              }

              updatedCamposBasicosData[key].value = fieldValue;
            }
          }
          updatedCamposBasicos[idx].data = updatedCamposBasicosData
        })
        setCamposBasicos(updatedCamposBasicos);
      }


      setUsuario(data);

    } catch (error) {
      errorMessage(error)
    }
  };

  const nuevoUsuario = async (id) => {
    try {
      const data = await resourcesServices.nuevoResource('usuarios');
      if(rol){
        data.rol = rol
      }
      data.confirmar_email = ''
      setUsuario(data);
    } catch (error) {
      errorMessage(error)
    }
  };

  const obtenerRoles = async () => {
    try {
      const data = await resourcesServices.obtenerResources('usuarios/obtenerRoles');
      setRoles(data.data);
    } catch (error) {
      errorMessage(error)
    }
  };

  const cambiarEstadoRelacion = async (apoderados_usuario_id) => {
    try {
      if(!window.confirm('Está seguro que quiere cambiar el estado ?')){
        return;
      }

      const data = await resourcesServices.actualizarResource(`usuarios/${usuario.id}/cambiarEstadoRelacion`, apoderados_usuario_id, {usuario: {id: usuario.id}});

      setUsuario(data);


    } catch (error) {
      errorMessage(error)
    }
  };

  const guardarUsuario = async () => {
    try {

      if( esNuevo && authInformation.rol === 'MesaEntrada' && rol === 'Apoderado' ){
        if(!verificarEmail()){
          alert("Ingrese su email y su verifique que la confirmación sea el mismo email.");
          return;
        }
      }

      let data;

      const copiaUsuario = {...usuario}
      if(!esNuevo){
        delete copiaUsuario.rol
        delete copiaUsuario.password
        delete copiaUsuario.password_confirmation
      }

      delete copiaUsuario.preferencias_usuario

      const attributeName = 'usuario'

      const formData =  new FormData();
      for(const [key, value] of Object.entries(copiaUsuario)){
        if(value !== null){
          if(key === "documentos"){
            for(let i = 0; i < value.length; i++){
              formData.append(`${attributeName}[${key}][]`, value.item(i), value.item(i).name)
            }
          } else {
            formData.append(`${attributeName}[${key}]`, value)
          }
        }
      }

      if(esNuevo){
        formData.append(`${attributeName}[rol_usuarios_attributes][][rol_id]`, copiaUsuario.rol_id)
        data = await resourcesServices.crearResource('usuarios', formData);
      } else {
        data = await resourcesServices.actualizarResource('usuarios', copiaUsuario.id, formData);
      }

      if(authInformation.usuario_id == data.id){
        setAuthInformation({...authInformation,
          ['nombre']: data.nombre
        })
      }

      setUsuario(data);

      window.alert("Información actualizada")
      if(esNuevo){
        navigate(`/usuarios`);
      }

    } catch (error) {
      errorMessage(error)
    }
  };

  const actualizacionApoderado = async () => {
    try {

      const copiaUsuario = {...usuario}

      if(selectedUser.value > 0){
        if(usuario.rol_actual === "Obligado"){
          copiaUsuario.apoderados_usuarios_attributes = [{usuario_apoderado_id: selectedUser.value}]
        }

        if(usuario.rol_actual === "Apoderado"){
          copiaUsuario.apoderados_usuarios_attributes = [{usuario_notificado_id: selectedUser.value}]
        }
      }

      const data = await resourcesServices.actualizarResource('usuarios', copiaUsuario.id, {usuario: copiaUsuario});

      setUsuario(data);

      window.alert("Información actualizada")
      if(esNuevo){
        navigate(`/usuarioForm/${data.id}`);
      }


    } catch (error) {
      errorMessage(error)
    }
  };


  const handleInput = (e) => {
    const { name, value, type } = e.target;

    if(type === 'checkbox') {
      if(name === 'es_supervisor') {
        setUsuario({...usuario,
          [name]: !usuario.es_supervisor
        })
      } else if(name === 've_notificaciones') {
        setUsuario({...usuario,
          [name]: !usuario.ve_notificaciones
        })
      }
    } else {
      setUsuario({...usuario,
        [name]: value
      })
    }
  }

  const tituloComponente = () => {
    if (esNuevo) {
      if(rol && authInformation.rol === 'MesaEntrada'){
        return 'Crear Apoderado / Patrocinante'
      } else {
        return 'Crear Usuario'
      }
    } else {
      return `${usuario.nombre} ${usuario.apellido}`
    }
  }

  const handleInputNombreUsuario = async (newValue) => {
    if(newValue !== null){
      setSelectedUser(newValue)
    }
  }

  const verificarEmail = () => {
    return usuario.email && usuario.email && usuario.email.length>0 && usuario.email === usuario.confirmar_email
  }

  const buscarUsuario = async(inputValue) => {
    try {
      // if( inputValue.length < 3 ){
      //   return []
      // }

      const endpoint = usuario.rol_actual === "Obligado" ? "buscarApoderado" : "buscarNotificado";

      const results = await resourcesServices.obtenerResources(`usuarios/${endpoint}`, '', {query: inputValue});

      const usuarioOptions = results.data.map((usuario) => ({
        value: usuario.id,
        label: `${usuario.nombre} ${usuario.apellido}`,
      }));

      // return [];
      return usuarioOptions;
    } catch (error) {
      errorMessage(error)
      return {};
    }
  }

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setUsuario({...usuario,
      [name]: files
    })
  };

  // https://stackoverflow.com/questions/54218351/changing-height-of-react-select-component
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minWidth: '450px'
    }),
  };

  const listaDeclaracionesJuradas = (estado) => {
    return (
      <>
      {
        declaracionesJuradas.filter(dj => dj.estado===estado).length > 0 && (
          <>
            { estado === 'aprobado' && (
              <h4 className='bg-success p-2'>Aprobadas</h4>
            ) }
            { estado === 'creado' && (
              <h4 className='bg-warning p-2'>Pendientes</h4>
            ) }
            { estado === 'rechazado' && (
              <h4 className='bg-danger text-light p-2'>Rechazadas</h4>
            ) }

            <table className="table table-striped table-responsive" style={{tableLayout: 'fixed', width: '100%'}}>
              <thead>
                <tr className='text-start'>
                  <th style={{width: '40%'}} scope="col">Cargo | Organismo</th>
                  <th style={{width: '20%'}} scope="col">Desde | Norma legal</th>
                  <th style={{width: '20%'}} scope="col">Hasta | Norma legal</th>
                  <th style={{width: '20%'}} scope="col">Declaración Jurada</th>
                </tr>
              </thead>
              <tbody>
                { declaracionesJuradas.filter(dj => dj.estado===estado).map(declaracion_jurada => (
                  <Fragment key={declaracion_jurada.id}>
                    <tr>
                      <td style={{whiteSpace: 'normal'}}>{declaracion_jurada.estado} - <b>{declaracion_jurada.cargo}</b> | {declaracion_jurada.organismo}</td>
                      <td style={{whiteSpace: 'normal'}}>{declaracion_jurada.f_cargo_desde_formated} | {declaracion_jurada.numero_alta_norma_legal}</td>
                      <td style={{whiteSpace: 'normal'}}>{declaracion_jurada.f_cargo_hasta_formated} | {declaracion_jurada.numero_baja_norma_legal}</td>
                      <td>
                        {
                          declaracion_jurada.archivoUrl && (
                            <Link to={declaracion_jurada.archivoUrl} className="btn btn-secondary" target='_blank'>Descargar</Link>
                          )
                        }
                      </td>
                    </tr>
                    {
                      (declaracion_jurada.estado === 'creado' || declaracion_jurada.estado === 'rechazado') && (
                        <tr>
                          <td colSpan={4} className='p-0'>
                            <div className="alert alert-danger text-light" role="alert">
                              { declaracion_jurada.estado === 'creado' && ('Pendiente de aprobación')}
                              { declaracion_jurada.estado === 'rechazado' && (`Motivo del rechazo: ${declaracion_jurada.motivo_rechazo}`)}
                            </div>
                          </td>
                        </tr>
                      )
                    }

                  </Fragment>
                  ))
                }
              </tbody>
            </table>
          </>
        )
      }
      </>
    )
  }

  const cambiarClave = async () => {
    try {
      if( !usuario.password || !usuario.password_confirmation ){
        window.alert("Ingrese la clave y la confirmación")
        return
      }
      const data = await resourcesServices.actualizarResource('usuarios', usuario.id, {usuario: {
        rol_actual: usuario.rol_actual,
        password: usuario.password || '',
        password_confirmation: usuario.password_confirmation || ''
      }});

      setUsuario(data);

      window.alert("Información actualizada")
      if(esNuevo){
        navigate(`/usuarioForm/${data.id}`);
      }


    } catch (error) {
      errorMessage(error)
    }
  }

  const crearNuevoRolAUsuario = async (nuevo_rol) => {
    try {
      if( !window.confirm("Está seguro ?") ){
        return;
      }

      setSaving(true)

      const data = await resourcesServices.crearResource(`usuarios/${id}/${rol}/asignarNuevoRol`, {rol_id: nuevo_rol.id});

      window.alert("Nuevo rol creado")
      navigate(`/usuarioForm/${data.id}/${nuevo_rol.nombre}`);

      setSaving(false)

    } catch (error) {
      setSaving(false)
      errorMessage(error)
    }
  }  


  return (
    <div>
      {renderHTML && (
        <>
        {
          !esNuevo && (
            <h5 className='mb-0'>{usuario.rol_actual==='Apoderado' ? 'Apoderado / Patrocinante' : usuario.rol_actual}</h5>
          )
        }
        <h1>{tituloComponente()} <BotonVolver /></h1>

        <div className="card">
          {/* <pre>{JSON.stringify(usuario, null, 2)}</pre> */}
          <div className="card-body px-0 pb-2 ms-3 me-3">
            <form>
            {
              !esNuevo && (usuario.rol_actual === "Obligado" || usuario.rol_actual === "Apoderado") && (
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button className="nav-link active" id="tab-1" data-bs-toggle="tab" data-bs-target="#tab-pane-1" type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true">Datos personales</button>
                  </li>
                  {
                    usuario.rol_actual === "Obligado" && (
                      <li className="nav-item" role="presentation">
                        <button className="nav-link" id="tab-3" data-bs-toggle="tab" data-bs-target="#tab-pane-3" type="button" role="tab" aria-controls="apoderado-tab-pane" aria-selected="false">
                          Apoderados / Patrocinantes
                        </button>
                      </li>

                    )
                  }
                  <li className="nav-item" role="presentation">
                    <button className="nav-link" id="tab-4" data-bs-toggle="tab" data-bs-target="#tab-pane-4" type="button" role="tab" aria-controls="declaracion-tab-pane" aria-selected="false">
                      Declaraciones Juradas
                    </button>
                  </li>
                </ul>
              )
            }
            <div className="tab-content" id="myTabContent">
              <div className="tab-pane fade show active" id="tab-pane-1" role="tabpanel" aria-labelledby="tab-1" tabIndex="0">
                {
                  authInformation.rol === 'Admin' && (
                    <>
                      <div className="card mb-5">
                        <div className="card-body">
                          <h5 className="card-title">Rol {!esNuevo && usuario.rol_actual}</h5>
                          <div className="mb-3">
                            {esNuevo ? (
                                <SelectControl
                                  value={usuario.rol_id}
                                  options={roles}
                                  name={'rol_id'}
                                  handleInput={handleInput}
                                  label={'Seleccione el rol'}
                                />
                            ): (
                              <>
                              Asignar nuevo rol a este usuario
                              <div>
                                {
                                  usuario.roles && roles.filter(r => !usuario.roles.map(r => r.nombre).includes(r.nombre)).map((rol, idx) => (
                                    <button key={idx} className="btn btn-primary me-3" type="button" onClick={()=> crearNuevoRolAUsuario(rol)}>
                                      Crear {rol.nombre}
                                    </button>
                                  ))
                                }
                              </div>
                              </>
                            )}

                            {
                              usuario.rol_actual === 'Notificador' && (
                                <>
                                <div className='form-check form-switch'>
                                  <input className='form-check-input' name={`es_supervisor`} checked={usuario.es_supervisor} onChange={(e)=>handleInput(e)} type='checkbox' role="switch" id={`switch_es_supervisor`} />
                                  <label className='form-check-label' htmlFor={`switch_es_supervisor`} >Es Supervisor</label>
                                </div>
                                <div className='form-check form-switch'>
                                  <input className='form-check-input' name={`ve_notificaciones`} checked={usuario.ve_notificaciones} onChange={(e)=>handleInput(e)} type='checkbox' role="switch" id={`switch_ve_todas_las_notificaciones`} />
                                  <label className='form-check-label' htmlFor={`switch_ve_todas_las_notificaciones`} >Ve todas las notificaciones</label>
                                </div>
                                </>
                              )
                            }

                          </div>                        
                        </div>
                      </div>
                    </>
                  )
                }

                <TextControl
                  value={usuario.nombre}
                  name={'nombre'}
                  handleInput={handleInput}
                  disabled={bloquearCampo}
                  />

                <TextControl
                  value={usuario.apellido}
                  name={'apellido'}
                  handleInput={handleInput}
                  disabled={bloquearCampo}
                  />

                <TextControl
                  value={usuario.documento_identidad}
                  name={'documento_identidad'}
                  handleInput={handleInput}
                  label='Documento de identidad'
                  disabled={!esNuevo}
                  />

                <TextControl
                  value={usuario.email}
                  name={'email'}
                  handleInput={handleInput}
                  type={'email'}
                  disabled={bloquearCampo}
                  />

                {
                  esNuevo && authInformation.rol === 'MesaEntrada' && rol === 'Apoderado' && (
                    <TextControl
                      value={usuario.confirmar_email}
                      name={'confirmar_email'}
                      handleInput={handleInput}
                      type={'confirmar_email'}
                      disabled={!esNuevo}
                      />
                  )
                }

                {
                  authInformation.rol === 'Admin' ? (
                    <>
                    <TextControl
                      value={usuario.usuario}
                      name={'usuario'}
                      handleInput={handleInput}
                      />
                    </>
                  ) : ( 
                    <div className=''>
                      <label>Usuario: </label> {usuario.usuario || (usuario.documento_identidad && `tc${usuario.documento_identidad}`)}
                    </div>
  
                  )
                }

                {
                  authInformation.rol === 'MesaEntrada' && usuario.rol_actual === 'Apoderado' && (
                    <>
                      <div className="card mb-3">
                        <div className="card-body">
                          <div className="mb-3">
                            <b>Documentación requerida</b>
                            <input placeholder="Adjunte los documentos" className="form-control" onChange={handleFileChange} name="documentos" type="file" id="documentos" multiple/>
                          </div>
                        </div>
                      </div>
                    </>
                  )
                }

                {
                  usuario.documentos_adjuntos && (
                    <>
                      <div className='card mb-3'>
                        <ul className='list-group list-group-flush'>
                        {
                          usuario.documentos_adjuntos && usuario.documentos_adjuntos.map((documento, index) => (
                            <li key={index} className='list-group-item'>
                              {documento.nombre}
                              <a href={documento.url} target='_blank' className='btn btn-success ms-3'>Descarcar</a>
                              {/* <button type="button" onClick={() => eliminarAdjunto(documento.id)} className='btn btn-danger ms-3'>Eliminar</button> */}
                            </li>
                          ))
                        }
                        </ul>
                      </div>
                    </>
                  )
                }

                {
                  authInformation.rol === 'Admin' && !esNuevo && (
                    <>
                      <div className='row'>
                        <div className="col-sm-2">
                          <button className="btn btn-primary" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
                            Cambio de Clave
                          </button>
                        </div>
                        <div className="col-sm-10">
                          <div className="collapse" id="collapseExample">
                            <div className='row'>
                              <div className='col-sm-5'>
                                <TextControl
                                  value={usuario.password}
                                  name={'password'}
                                  handleInput={handleInput}
                                  type='password'
                                  label='Clave nueva'
                                  />
                              </div>
                              <div className='col-sm-5'>
                                <TextControl
                                  value={usuario.password_confirmation}
                                  name={'password_confirmation'}
                                  handleInput={handleInput}
                                  type='password'
                                  label='Repita la clave nueva'
                                  />
                              </div>
                              <div className='col-sm-2'>
                                <button className="btn btn-primary" type="button" onClick={()=> cambiarClave()}>
                                  Modificar
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )
                }

                { !esNuevo && usuario && (usuario.rol_actual === "Apoderado" || usuario.rol_actual === "Obligado" || usuario.rol_actual === "MesaEntrada") && (
                  <>
                    <div className='my-3'>
                      {
                        camposBasicos.map((obj, idx) => (
                          <div key={idx} className="card mb-5">
                            <div className="card-body">
                              <h5 className="card-title">{obj.section}</h5>
                              {
                                Object.entries(obj.data).map(([key, value]) => (
                                  <div key={key}>
                                    <TextControlObligado
                                      autocompletar={value.autocompletar}
                                      value={value.value}
                                      options={value.options || []}
                                      type={value.tipo}
                                      declarado={false}
                                      attributeModelName={value.atributo || key}
                                      disabled={!esNuevo}
                                      handleInput={(e) => handleInput(e, 'camposBasicos')}
                                    />
                                  </div>
                                ))
                              }
                            </div>
                          </div>
                        ))
                      }

                      {
                      usuario && usuario.preferencias_usuario && usuario.preferencias_usuario.archivoRegistroPdf && (
                        <a href={usuario.preferencias_usuario.archivoRegistroPdf} target='_blank' className='btn btn-success ms-3'>Ver Formulario de Registro</a>
                        )
                      }
                    </div>
                  </>
                )}

                <div>
                  <button className="btn btn-primary mt-3" disabled={esVeedor} onClick={()=>guardarUsuario()} type="button">Guardar</button>
                </div>

              </div>

              <div className="tab-pane fade" id="tab-pane-3" role="tabpanel" aria-labelledby="tab-3" tabIndex="0">
                {!esNuevo && usuario && (
                  <>
                  {(usuario.rol_actual === "Apoderado" || usuario.rol_actual === "Obligado") && (
                    <>
                      <div className='my-3'>
                        {
                          (usuario.rol_actual === "Apoderado") ? (
                            <h4>Obligados</h4>
                          ) : (
                            <h4>Apoderados / Patrocinantes</h4>
                          )
                        }
                        <table className="table align-middle">
                          <thead>
                            <tr>
                              <th scope="col">Nombre</th>
                              <th scope="col">Estado</th>
                              <th scope="col"></th>
                            </tr>
                          </thead>
                          <tbody>
                            { usuario.rol_actual === "Apoderado" ?
                              (
                                usuario.apoderados_usuarios && usuario.apoderados_usuarios.length > 0 && usuario.apoderados_usuarios.sort((a, b) => a.estado > b.estado ? 1 : -1).map(au => (
                                  <tr className={`${au.estado === 'inactivo' ? 'table-danger' : 'table-success'}`} key={au.id}>
                                    <td><b>{au.usuario_notificado && au.usuario_notificado.nombre} {au.usuario_notificado && au.usuario_notificado.apellido}</b></td>
                                    <td>{au.estado}</td>
                                    <td><button disabled={esVeedor} onClick={()=>cambiarEstadoRelacion(au.id)} type="button" className='btn btn-primary mb-0' >{au.estado === 'activo' ? 'Inactivar' : 'Activar'}</button></td>
                                  </tr>
                                ))
                              )
                              :
                              (
                                usuario.apoderados_usuarios && usuario.apoderados_usuarios.length > 0 && usuario.apoderados_usuarios.sort((a, b) => a.estado > b.estado ? 1 : -1).map(au => (
                                  <tr className={`${au.estado === 'inactivo' ? 'table-danger' : 'table-success'}`} key={au.id}>
                                    <td><b>{au.usuario_apoderado && au.usuario_apoderado.nombre} {au.usuario_apoderado && au.usuario_apoderado.apellido}</b></td>
                                    <td>{au.estado}</td>
                                    <td><button disabled={esVeedor} onClick={()=>cambiarEstadoRelacion(au.id)} type="button" className='btn btn-primary mb-0' >{au.estado === 'activo' ? 'Inactivar' : 'Activar'}</button></td>
                                  </tr>
                                ))
                              )
                            }
                          </tbody>
                        </table>
                      </div>
                      {
                        !esVeedor && (
                          <>
                            <div className="mb-3 w-50">
                              <h4>Asociar nuevo {usuario.rol_actual === "Apoderado" ? 'obligado' : 'apoderado / patrocinante'}</h4>
                              <AsyncSelect
                                  loadOptions={(e) => buscarUsuario(e)}
                                  placeholder="Buscar por nombre..."
                                  onChange={(e) => handleInputNombreUsuario(e)}
                                  value={selectedUser}
                                  styles={customStyles}

                                />
                            </div>
                            {selectedUser.label && selectedUser.label.length > 0 && selectedUser.value > 0 && (
                              <div className='mb-3'>
                              Confirme el alta de <b>{selectedUser.label}</b>
                              <br />
                              <button onClick={()=>actualizacionApoderado()} type="button" className='btn btn-primary my-3' >Confirmar</button>
                              </div>
                            )}
                          </>
                        )
                      }
                    </>
                  )}
                  </>
                )}

              </div>

              <div className="tab-pane fade" id="tab-pane-4" role="tabpanel" aria-labelledby="tab-4" tabIndex="0">
                {
                  (authInformation.rol === 'Obligado' || authInformation.rol === 'Apoderado') && (
                    <div className='mt-3 mb-3'>
                      <Link to={'/declaracionJuradaForm/new'} className="btn btn-secondary" >Nueva Declaración Jurada</Link>
                    </div>
                  )
                }

                
                {listaDeclaracionesJuradas('aprobado')}

                {
                  (authInformation.rol === 'Obligado' || authInformation.rol === 'Apoderado' || authInformation.rol === 'MesaEntrada' || authInformation.rol === 'Admin') && (
                    <>
                    {listaDeclaracionesJuradas('creado')}

                    {listaDeclaracionesJuradas('rechazado')}                    
                    </>
                  )
                }

              </div>
            </div>


            </form>
          </div>
        </div>
        </>
      )}
    </div>
  );
};

export default UsuarioFormPartial;